export type BrandId = 'mirasee' | 'story-coach';

export type CampaignBrand = {
  id: BrandId;
  name: string;
  copyrightName: string;
  fonts: string[];
  defaultLogoUrl?: string;
  termsUrl?: string;
};

export const CAMPAIGN_BRANDS: Record<BrandId, CampaignBrand> = {
  mirasee: {
    id: 'mirasee',
    name: 'Mirasee',
    copyrightName: 'Mirasee',
    fonts: ['Montserrat:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,600;1,700'],
    defaultLogoUrl: 'https://playground.mirasee.com/mirasee-logo-color.png',
  },
  'story-coach': {
    id: 'story-coach',
    name: 'Story Coach',
    copyrightName: 'Story Coach',
    fonts: ['Gentium+Book+Basic:ital,wght@0,400;0,700;1,400', 'Bentham'],
    defaultLogoUrl: 'https://i.ontraport.com/266096.bdffc333fe0c435732652c78ab646525.PNG',
    termsUrl: 'https://story-coach.com/terms-conditions/',
  },
};

export function getBrand(brandId?: string): CampaignBrand {
  if (brandId && brandId in CAMPAIGN_BRANDS) {
    return CAMPAIGN_BRANDS[brandId as BrandId];
  }
  return CAMPAIGN_BRANDS.mirasee;
}
